/*
 *
 * Package: `@dbh/toggle-theme`.
 *
 */const THEME_KEY_TOGGLE="toggleTheme";const modifyToggleTheme=a=>{let{colors:{brandSecond:b,greyUltralight:c,greySuperlight:d}}=a;return {[THEME_KEY_TOGGLE]:{unchecked:{backgroundColor:c,borderColor:d,shadowColor:d},checked:{backgroundColor:b,borderColor:b,shadowColor:b}}}};

export { THEME_KEY_TOGGLE, modifyToggleTheme as default };
